import { Box, Container } from '@material-ui/core';

const KeepaLayout = (props) => {
	const { buttonComponent, actionBar, children, ...rest } = props;

	return (
		<>
			<Box
				bgcolor={'#FFF'}
				zIndex={10}
				width="100%"
				position={rest?.actionSticky ? 'sticky' : 'static'}
				top={0}
			>
				{actionBar}
			</Box>
			<Container disableGutters={rest.disableGutters}>
				<Box style={{ marginBottom: rest?.marginBottom }}>{children}</Box>
				{buttonComponent && (
					<Box
						className="fixedToBottom"
						style={{
							...(rest?.isShadow && { boxShadow: ' 0px 0px 50px 3px rgba(1, 1, 1, 0.08)' }),
						}}
					>
						{buttonComponent}
					</Box>
				)}
			</Container>
		</>
	);
};

KeepaLayout.defaultProps = {
	actionSticky: false,
	marginBottom: '150px',
	isShadow: true,
};

export default KeepaLayout;
